/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProviderLicenseList } from '../models/PaginatedProviderLicenseList';
import type { PatchedProviderLicenseWrite } from '../models/PatchedProviderLicenseWrite';
import type { ProviderLicense } from '../models/ProviderLicense';
import type { ProviderLicenseWrite } from '../models/ProviderLicenseWrite';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProviderLicensesService {

    /**
     * @returns PaginatedProviderLicenseList
     * @throws ApiError
     */
    public static providerLicensesList({
        limit,
        offset,
        provider,
    }: {
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        provider?: string,
    }): CancelablePromise<PaginatedProviderLicenseList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider-licenses/',
            query: {
                'limit': limit,
                'offset': offset,
                'provider': provider,
            },
        });
    }

    /**
     * @returns ProviderLicense
     * @throws ApiError
     */
    public static providerLicensesCreate({
        requestBody,
    }: {
        requestBody: ProviderLicenseWrite,
    }): CancelablePromise<ProviderLicense> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/provider-licenses/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderLicense
     * @throws ApiError
     */
    public static providerLicensesRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this license.
         */
        id: string,
    }): CancelablePromise<ProviderLicense> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider-licenses/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProviderLicense
     * @throws ApiError
     */
    public static providerLicensesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this license.
         */
        id: string,
        requestBody?: PatchedProviderLicenseWrite,
    }): CancelablePromise<ProviderLicense> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/provider-licenses/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static providerLicensesDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this license.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/provider-licenses/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
